import { defineMessage } from 'services/localization';

export const messages = {
    anyFieldName: defineMessage('any_fieldname'),
    fieldNameMatches: defineMessage('fieldname_matches'),
    fieldNameDoesNotMatch: defineMessage('fieldname_does_not_match'),
    selectFieldName: defineMessage('select_fieldname'),
};
